export default __webpack_public_path__ + "static/media/school.1c0889e0.png";